import { Language } from '../shared/constants';

export const LocalStorageKey = {
  language: 'language',
  timers: 'timers',
} as const;

type LocalStorageKeyType = keyof typeof LocalStorageKey;

const defaultValues: Record<LocalStorageKeyType, any> = {
  [LocalStorageKey.language]: Language.en,
  [LocalStorageKey.timers]: {},
};

const prefix = 'sg-';
const getLocalStorageKey = (key: LocalStorageKeyType): string => {
  return `${prefix}${key}`;
};

// todo refactor to hook
export class LocalStorageService {
  static setValue(key: LocalStorageKeyType, value: unknown): void {
    localStorage.setItem(
      getLocalStorageKey(key),
      typeof value === 'object' ? JSON.stringify(value) : String(value),
    );
  }

  static getValue<T = unknown>(key: LocalStorageKeyType): T | string | null {
    const currentValue = localStorage.getItem(getLocalStorageKey(key));

    if (currentValue === null && defaultValues[key]) {
      const defaultValue = defaultValues[key];
      localStorage.setItem(
        getLocalStorageKey(key),
        typeof defaultValue === 'object'
          ? JSON.stringify(defaultValue)
          : defaultValue,
      );
      return defaultValue as T | string;
    }

    try {
      return JSON.parse(currentValue as string) as T;
    } catch (e) {
      return currentValue;
    }
  }

  static removeValue(key: LocalStorageKeyType): void {
    localStorage.removeItem(getLocalStorageKey(key));
  }
}
